import { Button } from '@heroui/react'
import { Pencil } from 'lucide-react'

export default function EditRowButton(props) {
  return (
    <Button
      isIconOnly
      variant="faded"
      color="primary"
      size="sm"
      disableRipple
      {...props}
    >
      <Pencil size={16} />
    </Button>
  )
}
